import { render, staticRenderFns } from "./order-defect.vue?vue&type=template&id=a9cbfc14&scoped=true&"
import script from "./order-defect.vue?vue&type=script&lang=js&"
export * from "./order-defect.vue?vue&type=script&lang=js&"
import style0 from "./order-defect.vue?vue&type=style&index=0&id=a9cbfc14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9cbfc14",
  null
  
)

export default component.exports